import { useDispatch, useSelector } from 'react-redux';
import { Common, color } from '@stockbit/ui';

// Components
import ConnectedFacebook from './ConnectedFacebook';
import NotConnectedFacebook from './NotConnectedFacebook';

// Store
import profileSlice, {
  effects as effectsProfile,
  selectors as selectorsProfile,
} from 'lib/entities/profile';

// Store onboarding
import { effects as effectsOnboarding } from 'lib/entities/onboarding';

// styled
import OnBoardingWrapper from '../styled';
import ConnectFacebookWrapper from './styled';

const { Iconmoon } = Common;

const FACEBOOK_CONNECT = 'facebook';

// ConnectFacebook Compoonent
function ConnectFacebook() {
  // request states profile
  const { data: dataProfile } = useSelector(selectorsProfile);

  // handle actions & effects
  const dispatch = useDispatch();

  // data profile
  const { onboarding: progress, facebook_id: isFacebookConnected } =
    dataProfile;

  const checkIsFacebookConnected = () =>
    isFacebookConnected !== null && isFacebookConnected !== '';

  /**
   * Go to any step in onboarding page and save it into database.
   * {web}../OnboardingPage/OnboardingPage.js
   * line: 127
   * @param {Object} event - Javascript Event object
   */
  const handleNextStep = (event) => {
    if (
      event.type === 'click' ||
      (event.type === 'keydown' && (event.key === 'Enter' || event.key === ' '))
    ) {
      // step: next onboarding step
      const nextStep = progress + 1;

      // hit API skip user/onboarding/
      dispatch(effectsOnboarding.userSkipOnboarding(parseInt(nextStep, 10)));
    }
  };

  /**
   * handlePreviousStep
   * Go to back step in onboarding page
   * replace 'onboarding' in profile state.
   * @param {Object} event - Javascript Event object
   */
  const handlePreviousStep = (event) => {
    if (
      event.type === 'click' ||
      (event.type === 'keydown' && (event.key === 'Enter' || event.key === ' '))
    ) {
      // step: previous onboarding step
      const previousStep = progress - 1;

      // Can't hit API because it will return error when set step to `0` (edit profile picture)
      dispatch(
        profileSlice.actions.updateOnboardingStep({ step: previousStep }),
      );
    }
  };

  /**
   * Links visible Facebook Connect button click to invisible FacebookLogin
   * component.
   */
  const connectFacebook = () => {
    if (!checkIsFacebookConnected()) {
      document.querySelector('.my-facebook-button-class.hide').click();
    }
  };

  /**
   * handleFacebookResponse
   * to dispatch connect facebook
   */
  const handleFacebookResponse = (response) => {
    const userId = response.id || response.userID;
    if (response.accessToken && userId) {
      const requestBody = {
        fb_user_id: userId,
        fb_access_token: response.accessToken,
      };

      dispatch(
        effectsProfile.userConnectSocialMedia({
          socialMediaName: FACEBOOK_CONNECT,
          requestBody,
        }),
      );
    }
  };

  return (
    <OnBoardingWrapper>
      <div className="boarding-cover">
        <div className="boarding-content">
          <ConnectFacebookWrapper className="boarding-in facebook">
            {!checkIsFacebookConnected() ? (
              <NotConnectedFacebook
                handleNextStep={handleNextStep}
                connectFacebook={connectFacebook}
                handleFacebookResponse={handleFacebookResponse}
              />
            ) : (
              <ConnectedFacebook handleNextStep={handleNextStep} />
            )}

            {/* back to step upload profile picture */}
            <div
              role="button"
              tabIndex={-1}
              className="boarding-button-back"
              onClick={handlePreviousStep}
              onKeyDown={handlePreviousStep}
            >
              <Iconmoon
                size="25px"
                className="icon-toolbar_prev"
                color={color.dimGray}
                hoverColor={color.lowgray}
              />
            </div>
          </ConnectFacebookWrapper>
        </div>
      </div>
    </OnBoardingWrapper>
  );
}

export default ConnectFacebook;
